<template>
  <!-- eslint-disable -->
  <div>
    <svg
      v-bind:style="{ transform: 'rotate(' + (shift * -360 % 360) + 'deg)' }"
      class="picker__svg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="100%"
      height="100%"
      viewBox="-10 -10 220 220"
    >
      <defs>
        <linearGradient
          v-bind:id="'redyel-' + id"
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="0"
          x2="1"
          y2="1"
        >
          <stop offset="0%" v-bind:stop-color="colors[0]"></stop>
          <stop offset="100%" v-bind:stop-color="colors[1]"></stop>
        </linearGradient>
        <linearGradient
          v-bind:id="'yelgre-' + id"
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="0"
          x2="0"
          y2="1"
        >
          <stop offset="0%" v-bind:stop-color="colors[1]"></stop>
          <stop offset="100%" v-bind:stop-color="colors[2]"></stop>
        </linearGradient>
        <linearGradient
          v-bind:id="'grecya-' + id"
          gradientUnits="objectBoundingBox"
          x1="1"
          y1="0"
          x2="0"
          y2="1"
        >
          <stop offset="0%" v-bind:stop-color="colors[2]"></stop>
          <stop offset="100%" v-bind:stop-color="colors[3]"></stop>
        </linearGradient>
        <linearGradient
          v-bind:id="'cyablu-' + id"
          gradientUnits="objectBoundingBox"
          x1="1"
          y1="1"
          x2="0"
          y2="0"
        >
          <stop offset="0%" v-bind:stop-color="colors[3]"></stop>
          <stop offset="100%" v-bind:stop-color="colors[4]"></stop>
        </linearGradient>
        <linearGradient
          v-bind:id="'blumag-' + id"
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="1"
          x2="0"
          y2="0"
        >
          <stop offset="0%" v-bind:stop-color="colors[4]"></stop>
          <stop offset="100%" v-bind:stop-color="colors[5]"></stop>
        </linearGradient>
        <linearGradient
          v-bind:id="'magred-' + id"
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="1"
          x2="1"
          y2="0"
        >
          <stop offset="0%" v-bind:stop-color="colors[5]"></stop>
          <stop offset="100%" v-bind:stop-color="colors[0]"></stop>
        </linearGradient>
      </defs>
      <ellipse
        class="ellipse"
        cx="100"
        cy="100"
        rx="100.95"
        ry="100.95"
        fill="none"
        stroke="#212121"
      ></ellipse>
      <g fill="none" transform="translate(100,100)">
        <path d="M -1,-100 A 100,100 0 0,1 86.6,-50" v-bind:stroke="'url(#redyel-' + id + ')'"></path>
        <path d="M 86,-51 A 100,100 0 0,1 86.6,50" v-bind:stroke="'url(#yelgre-' + id + ')'"></path>
        <path d="M 87,49 A 100,100 0 0,1 0,100" v-bind:stroke="'url(#grecya-' + id + ')'"></path>
        <path d="M 1,100 A 100,100 0 0,1 -86.6,50" v-bind:stroke="'url(#cyablu-' + id + ')'"></path>
        <path d="M -86,51 A 100,100 0 0,1 -86.6,-50" v-bind:stroke="'url(#blumag-' + id + ')'"></path>
        <path d="M -87,-49 A 100,100 0 0,1 0,-100" v-bind:stroke="'url(#magred-' + id + ')'"></path>
      </g>
    </svg>
  </div>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Picker',
  data: function() {
    return { id: null };
  },
  props: {
    colors: Array,
    shift: Number
  },
  mounted() {
    this.id = this._uid;
  }
};
</script>


